import en from './en';
import es from './es';

const translations = { en, es };

export default translations;